import React from 'react';
import { FolderPlusIcon, LayersIcon } from 'lucide-react';
interface EmptyCollectionsProps {
  onCreateNew: () => void;
}
export const EmptyCollections = ({
  onCreateNew
}: EmptyCollectionsProps) => {
  return <div className="text-center py-16 px-4" data-id="element-168">
      <div className="flex justify-center" data-id="element-169">
        <div className="relative" data-id="element-170">
          <LayersIcon className="h-12 w-12 text-gray-300" data-id="element-171" />
          <FolderPlusIcon className="absolute -right-2 -bottom-2 h-8 w-8 text-blue-500" data-id="element-172" />
        </div>
      </div>
      <h3 className="mt-4 text-lg font-medium text-gray-900" data-id="element-173">
        No collections found
      </h3>
      <p className="mt-1 text-sm text-gray-500 max-w-md mx-auto" data-id="element-174">
        Get started by creating your first product collection. Collections can
        contain SPUs (entire product lines) or specific SKUs (individual
        variants).
      </p>
      <div className="mt-6" data-id="element-175">
        <button onClick={onCreateNew} className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-176">
          <FolderPlusIcon className="h-5 w-5 mr-2" data-id="element-177" />
          Create New Collection
        </button>
      </div>
    </div>;
};